export enum AvailabilityType {
  ASSIGN = "ASSIGN",
  BLOCK = "BLOCK",
  EXTEND = "EXTEND"
}
